import { render } from "./upload-doc.vue?vue&type=template&id=e9ea4e22&scoped=true"
import script from "./upload-doc.vue?vue&type=script&lang=js"
export * from "./upload-doc.vue?vue&type=script&lang=js"

import "./upload-doc.vue?vue&type=style&index=0&id=e9ea4e22&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ea4e22"]])

export default __exports__